import { styled, TableHead as MuiTableHead, TableRow } from "@mui/material"

const TableHead = styled(MuiTableHead)(() => ({}))

export const TableRowHead = styled(TableRow)({})

export default TableHead
